<template>
    <div class="drawer-con">
        <div class="drawer-content">
          <div class="swiper-container">
            <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item,index) in dataLink" :key="index">
                     <!-- <a class="nextToLink" :href="item.linkTo" target="_blank"> -->
                     <a class="nextToLink" :href="item.dapp_home_url" target="_blank">
                    <div class="swiper-slide-con">
                        <!-- <p class="slide-title"><img :style="{'width':item.width?item.width+'px':'auto'}" :src="require('../../assets/images/drawer/'+item.img)"/></p> -->
                        <p class="slide-title"><img :style="{'width':item.dapp_name == '北京互联网法院' || item.dapp_name == '广州互联网法院' ? '143px':'auto'}" :src="item.title_logo"/></p>
                         <p class="slide-desc">
                             <!-- {{item.desc}} -->
                             {{item.description}}
                         </p>
                         <div class="next-to-btn">
                             <!-- <a class="nextToLink" :href="item.linkTo" target="_blank"><span class="next-icon"></span></a> -->
                             <a class="nextToLink" :href="item.dapp_home_url" target="_blank"><span class="next-icon"></span></a>
                         </div>
                    </div>
                     </a>
                </div>
            </div>
           </div>
           <!-- 左箭头 -->
            <div class="swiper-button-prev"></div>
            <!-- 右箭头 -->
            <div class="swiper-button-next"></div>
        </div>
    </div>
</template>
<script>
import Swiper from 'swiper';
export default {
    name: 'swiperDrawer',
    data(){
       return {
           mySwiper:null,
            dataLink:[
                {
                    index:1,
                    title:"IP360全方位数据权益保护平台",
                    img:"ip360_zxss_logo.png",
                    desc:"IP360是真相科技基于区块链、云计算、大数据及人工智能技术自主开发的全方位数据权益保护开放式平台。",
                    linkTo:"https://www.ip360.net.cn"
                },
                {
                    index:2,
                    title:"Xcontract智能签约平台",
                    img:"xcontract_zxss_logo.png",
                    desc:"通过区块链技术对用户签名和用章进行设置及比对，在确保安全性的前提上解除用户在空间和时间上的局限，随时随地可以完成合同签订、订单确认等商务操作，不再需要耗费大量的人力物力。",
                    linkTo:"https://www.xcontract.cn"
                },
                {
                    index:3,
                    title:"真相搜索",
                    img:"zxss_logo.png",
                    desc:"真相搜索是真相公司自主研发掌握核心技术的全新交互式互联网搜索引擎，深度挖掘互联网海量数据信息，并可对搜索结果进行在线存证，形成满足司法要求的电子数据证据。",
                    linkTo:"http://www.truthso.com"
                },
                {
                    index:4,
                    title:"真相取证APP",
                    img:"zxqzapp_zxss_logo.png",
                    desc:"采用公安部主体身份识别系统，在用户进行取证时，将数据上传区块链保存；包括取证时手机GPS定位的地理位置和由国家授时中心授时的时间、CA等。",
                    linkTo:"http://www.truthso.com/aboutTruthso/products"
                },
                {
                    index:5,
                    title:"北京市方正公证处区块链取证公证平台",
                    img:"gzc_zxss_logo.png",
                    desc:"采用北斗卫星授时、实名认证、数字指纹等技术保证电子数据真实有效，电子证据经过公安部云服务安全能力检验。运用云计算、区块链技术，电子证据平台自动取证等以提供优质可靠服务。",
                    linkTo:"http://www.bjnetnotary.com"
                },
                {
                    index:19,
                    title:"北京市方圆公证处区块链取证公证平台",
                    img:"gzc_fy_zxss_logo.png",
                    desc:"依托区块链、大数据、深度学习等技术，并采用时间戳、GPS定位、公安部主体身份识别、数据加密存储、数据指纹区块链存储等技术，保证电子证据的真实性、合法性。",
                    linkTo:"http://www.bjnetnotary.cn/index"
                },{
                    index:19,
                    title:"北京市精诚公证处电子数据存证系统",
                    img:"jingcheng_zxss_logo.png",
                    desc:"提供在线取证、公证服务，覆盖取证全场景，实时上传云端存证为电子证据，并采用时间戳、区块链存储等技术，确保证据的可追溯、安全合法。让您足不出户完成公证。",
                    linkTo:"https://jcyunzheng.com",
                },{
                    index:19,
                    title:"广州市广州公证处区块链电子数据保...",
                    img:"gzgzcsjbqxt.png",
                    desc:"以区块链技术为支撑，提供在线确权、取证、公证服务，适用多种业务场景，对产生的电子数据进行固化保全、加密存储，保障电子数据完整、合规、可追溯。",
                    linkTo:"http://bq.gz-notary.com",
                },
                {
                    index:19,
                    title:"广州市广州公证处区块链赋强公证系...",
                    img:"gzgzcfqgzxt.png",
                    desc:"为解决不良贷款催收难的痛点问题提供技术路径，大大简化不良贷款处置流程为金融机构提供线上强执公证服务，通过线上赋强公证服务平台，将公证处与银行业务进行链接。",
                    linkTo:"http://fq.gz-notary.com",
                },
                {
                    index:6,
                    title:"杭州互联网公证处电子证据保管平台",
                    img:"hzhlwgzc_zxss_logo.png",
                    desc:"采用金融级数据安全云存储，以司法联盟区块链为底层技术，拥有高等级的安全系数。通过区块链哈希加密防篡改，以保障电子证据能被客观、真实、有效地再现。",
                    linkTo:"https://www.netnotary.cn/index"
                },
                {
                    index:7,
                    title:"广州市海珠公证处区块链取证公证平台",
                    img:"gdhzgzc_zxss_logo.png",
                    desc:"拥有多种取证工具、线上线下一体化、赋能行政执法，互联网电子证据存于司法联盟链节点，轻松做到证据的流转，为司法联盟链生态贡献力量。",
                    linkTo:"http://www.hzgzc.cn/index"
                },
                {
                    index:8,
                    title:"内蒙古痕迹电子证据保管平台",
                    img:"nmghj_zxss_logo.png",
                    desc:"为者常成痕迹取证平台，以司法联盟区块链为底层技术，拥有高等级的安全系数。通过区块链哈希加密防篡改，以保障电子证据能被客观、真实、有效地再现。",
                    linkTo:"http://39.107.110.94/index"
                },
                {
                    index:9,
                    title:"温州市华东公证处区块链取证公证平台",
                    img:"wzshdgzc_zxss_logo.png",
                    desc:"中国互联网+司法的区块链基础设施，全联盟成员共同保证电子数据流转全过程真实、可信、可追溯，皆在助力各行业可信发展。",
                    linkTo:"http://121.43.13.193/index"
                },{
                    index:9,
                    title:"成都市国力公证处区块链取证公证平台",
                    img:"cdguoli_zxss_logo.png",
                    desc:"集在线取证、公证等功能于一体，依托司法联盟链，结合多项客观性应用技术，保证证据的有效性和真实性。解决取证难、维权难、诉讼难等诸多问题，为权利人提供强有力的客观证据支持。",
                    linkTo:"http://gl.scglgzc.com/",
                },
                {
                    index:10,
                    title:"沧州市渤海公证处区块链取证公证平台",
                    img:"czsbhgzc_zxss_logo.png",
                    desc:"以司法联盟区块链为底层技术，系统安全等级达到公安部警用标准，通过区块链哈希加密防篡改，24小时不打烊，全方位取证，即时申请公证！",
                    linkTo:"http://bhnetnotary.bhgzc.com/index"
                },
                {
                    index:11,
                    title:"区块链执法记录仪",
                    img:"zfjlychain_zxss_logo.png",
                    desc:"集合拍照、录像、录音、通话、网页以及视频取证，在线存证、在线公证等功能，形成了“现场取证+云端存证+后期出证”的综合可信执法记录。",
                    linkTo:"http://www.truthso.com/aboutTruthso/MobileArray"
                },
                {
                    index:12,
                    title:"legalXchain司法联盟链",
                    img:"legalxchain_zxss_logo.png",
                    desc:"以技术驱动，专注于电子数据主权确定及网络行为分析，以构建数字世界的文明秩序为愿景，依托云计算、人工智能、区块链、大数据、深度学习等技术进行计算法律学实践。",
                    linkTo:"https://www.legalxchain.com"
                },
                 {
                    index:13,
                    title:"北京互联网法院",
                    img:"bjic_logo.png",
                    desc:"联合北京市高院、司法鉴定中心、公证处等司法机构，以及行业组织、大型央企、大型金融机构、大型互联网平台等20家单位作为节点共同组建了“天平链”。",
                    linkTo:"http://sspt.bjinternetcourt.gov.cn/cas/login",
                    width:143
                },
                {
                    index:14,
                    title:"杭州互联网法院诉讼平台",
                    img:"hzcoti_logo.png",
                    desc:"依托互联网技术，完成起诉、立案、举证、开庭、裁判、执行全流程在线化，实现便民诉讼，节约司法资源。",
                    linkTo:"https://www.netcourt.gov.cn/",
                    width:157
                },
                {
                    index:15,
                    title:"广州州互联网法院",
                    img:"gzcoti_logo.png",
                    desc:"全面发挥司法在推动网络经济创新发展、保障网络安全、构建互联网治理体系方面的职能作用而增设的互联网法院。",
                    linkTo:"https://ols.gzinternetcourt.gov.cn",
                     width:143
                },
                {
                    index:16,
                    title:"佛山市电子证据固化平台",
                    img:"foshanbq_logo.png",
                    desc:"佛山市电子证据固化平台,集合多种取证工具,满足客户多样化的取证场景,取证数据存于司法联盟链节点,安全不可篡改。线上线下一体化,足不出户申请公证,快速制证。",
                    linkTo:"http://www.ec-owl.com/",
                    width:170
                },{
                    index:17,
                    title:"EC源数字备案平台",
                    img:"ecY_logo.png",
                    desc:"一个创新的区块链版权保护平台，我们尊重作者的权益，作品上传完成后，利用区块链技术系统会自动对作品进行确权，证据可追溯、维权效率高。数据加密存储到云端，安全更有保障。",
                    linkTo:"http://www.ec-origin.com/",
                     width:143
                },
                {
                    index:18,
                    title:"蓝信电子签约平台",
                    img:"lanxin_logo.png",
                    desc:"蓝信APP提供的“电子签约”应用，将电子化合同、协议等进行数字化签章并推送至签约对方，对方也可在电子签约中完成查看、签章动作。",
                    linkTo:"https://www.lanxin.cn/E-signing/index.html",
                    width:143
                },
                {
                    index:18,
                    title:"南昌市大成公证处区块链取证公证平台",
                    img:"gzc_zxss_logo1.png",
                    desc:"提供区块链电子证据存证、确权、公证等服务，基于区块链技术，并采用时间戳、GPS定位、公安部主体身份识别、数据加密存储、数据指纹等技术，确保证据的完整、合法性、可追溯。",
                    linkTo:"http://59.110.218.209/index/home",
                    width:170
                }
            ]
       }
    },
    methods:{
        getUrlList(){
            this.$axios.request({
                // url: "http://192.168.1.84:9060/dapp/v2/getDappList",
                url: "/webapi/getDappList",
                method: "GET",
                params: {}
            }).then(res => {
                if (res.data.code == 200) {
                    let list = res.data.datas.menuList;
                    this.dataLink= [];
                    for(let i in list) {
                        if(list[i].display == 1 && list[i].category !=4) {
                            this.dataLink.push(list[i]);
                        }
                    }
                } else {
                }
            });
        }
    },
    mounted(){
        this.getUrlList();
        setTimeout(()=> {
            this.mySwiper = new Swiper('.swiper-container', {
                autoplay: {
                     disableOnInteraction: false,
                     delay: 3000,
                },
                slidesPerView :5,
                loop:true,
                 navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                 },
            })
            this.mySwiper.el.onmouseover = ()=>{
                this.mySwiper.autoplay.stop();
            }
            this.mySwiper.el.onmouseout = ()=>{
                this.mySwiper.autoplay.start();
            }
        },150)
    }
}
</script>
<style scoped lang="scss">
    @import "../../assets/css/swiper.css";
    .drawer-con{
        width: 100%;
        height: auto;
    }
    .drawer-content{
            width: 1200px;
            margin:0 auto;
            height: 100%;
            // background: bisque;
            .swiper-container{
                z-index: 0;
            }
             .swiper-slide{
                width:300px;/*设为固定值*/
                padding:10px 0px;
                padding-left:10px;
                box-sizing: border-box;
                .swiper-slide-con{
                    width: 100%;
                    height: auto;
                    overflow: hidden;
                    .slide-title{
                        width: 100%;
                        height: 50px;
                        box-sizing: border-box;
                        padding: 5px 10px;
                        border-radius:10px 10px 0 0;
                        background: rgba(0, 0,0,0.2);
                        display: flex;
                        align-items: center;
                    }
                     .slide-desc{
                         width: 100%;
                         background: #FFFFFF;
                        font-size:12px;
                        font-family:PingFangSC-Regular,PingFang SC;
                        font-weight:400;
                        color:rgba(50,50,50,1);
                        line-height:18px;
                        box-sizing: border-box;
                        padding: 10px;
                        text-align:justify!important;
                        height: 110px;
                        overflow-y:auto;
                        overflow-x: hidden; 
                        &::-webkit-scrollbar {
                            width: 3px;
                        }
                        &::-webkit-scrollbar-thumb{
                            background: #ccc;
                        }
                     }
                     .next-to-btn{
                         width: 100%;
                         height: 32px;
                         background: #F0F0F0;
                      
                         border-radius:0 0 10px 10px;
                         box-sizing: border-box;
                         padding-right: 10px;
                         a{
                            width: 100%;
                            font-size:14px;
                            font-family:PingFangSC-Medium,PingFang SC;
                            font-weight:500;
                            height: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            color: #F5222D;
                         }
                         a:hover .next-icon{
                              color: #C3111B;
                              background: url("../../assets/images/drawer/jump_hov_pre_icon.png") no-repeat;
                              background-size: 100% 100%;
                         }
                         .next-icon{
                             display: inline-block;
                             width: 14px;
                             height: 14px;
                             background: url("../../assets/images/drawer/jump_nor_icon.png") no-repeat;
                             background-size: 100% 100%;
                         }
                     }
                }
            }
            .swiper-button-prev{
                left: -30px;
                z-index: 999999;
                top:55%;
                color: transparent;
                width:13px;
                height:24px;
                background: url("../../assets/images/drawer/leftside_nor_icon.png") no-repeat;
                background-size: 100% 100%;
                outline: none;
            }
            .swiper-button-prev:hover{
                background: url("../../assets/images/drawer/leftside_hov_pre_icon.png") no-repeat;
                background-size: 100% 100%;
            }
            .swiper-button-next{
                right: -40px;
                z-index: 999999;
                top:55%;
                color: transparent;
                width:13px;
                height:24px;
                background: url("../../assets/images/drawer/rightside_nor_icon.png") no-repeat;
                background-size: 100% 100%;
                outline: none;
            }
             .swiper-button-next:hover{
                background: url("../../assets/images/drawer/rightside_hov_pre_icon.png") no-repeat;
                background-size: 100% 100%;
            }
        }
</style>


// WEBPACK FOOTER //
// swiperDrawer.vue?1bfdc193